// extracted by extract-css-chunks-webpack-plugin
module.exports = {"collapsibleHeading":"Collapsible-1cdf256ce03fc1c9"};